import classNames from "classnames";

import { AscModuleSurveyQuestionType } from "@ascendnow/shared";
import {
  MODULE_SURVEY_AGREEMENT_ANSWERS,
  MODULE_SURVEY_FREQUENCY_ANSWERS,
} from "../../../lib";
import AscRadioButton from "../../AscInputFields/AscRadioButton/AscRadioButton";

import styles from "./AscModuleSurveyRadioGroup.module.scss";

export interface AscModuleSurveyRadioGroupProps {
  className?: string;
  type: AscModuleSurveyQuestionType;
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
  error: string;
  touched: boolean;
}

export default function AscModuleSurveyRadioGroup({
  className,
  type,
  name,
  onChange,
  onBlur,
  value,
  error,
  touched,
}: AscModuleSurveyRadioGroupProps) {
  const answers =
    type === "AGREEMENT"
      ? MODULE_SURVEY_AGREEMENT_ANSWERS
      : MODULE_SURVEY_FREQUENCY_ANSWERS;

  return (
    <div className={classNames(styles.ground, className)}>
      {answers?.map((answer) => (
        <div key={answer?.value} className={styles.fieldGroup}>
          <label className={styles.fieldLabel} htmlFor={name + answer?.value}>
            {answer?.label}
          </label>
          <AscRadioButton
            className={styles.inputField}
            id={name + answer?.value}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={answer?.value}
            checked={value === answer?.value}
            variant="secondary"
          />
        </div>
      ))}
      {error && touched && <div className={styles.fieldError}>{error}</div>}
    </div>
  );
}
